export const inOffice = () => {
  return window.Office && window.Office.context && !!Object.keys(window.Office.context).length;
};
export const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
export const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
export const inTeams = () => {
  return window.navigator?.userAgent?.indexOf('Teams/') > -1;
};
export const isEdge = window.navigator.userAgent.indexOf('Edge/') > -1;
